import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const PriorRatePage = () => {
  return(
    <HomeUI />
  )
}

export default PriorRatePage;
